module.exports = __webpack_public_path__ + "img/vacations.a3a9ab1f.svg";